import React, { useState, useRef } from 'react'
import {
  View,
  Platform,
  TouchableWithoutFeedback,
  Keyboard,
  Dimensions,
  KeyboardAvoidingView,
  TouchableOpacity
} from 'react-native'
import PropTypes from 'prop-types'
import moment from 'moment'

import { VFText, Icon, VFInput, VFDropdown } from '@vfgroup-oneplatform/foundation/Components'
import { withTheme, Colors } from '@vfgroup-oneplatform/foundation/Components/Themes'

import Permissions, { RESULTS } from 'react-native-permissions'

import _Modal from 'react-native-modal'

import Card from '../Card'
import HorizontalLine from '../HorizontalLine'
import VFButton from '../VFButton/VFButton'
import Modal from '../Modal'
import CameraStep from '../CameraStep'


import { Images, getThemeImages } from '../../Themes'

import styles from './Id.Styles'


console.error = () => null

function Id({
  currentIndex,
  changeCurrentIndex,
  personalInfo,
  setPersonalInfo,
  addressInfo,
  setAddressInfo,
  showExtendedCards,
  validatePersonalNumber,
  citiesList,
  countriesList,
  gendersList,
  documentTypeList,
  validatePhoneNumber,
  channelList,
  postForm,
  verifyCostumer,
  getAvaliableResources,
  API_KEY,
  setIsCostumer,
  theme,
  scrollRef,
  error
}) {

  const themedImages = getThemeImages(theme.name)

  const nameRef = useRef()
  const surnameRef = useRef()
  const idNumber = useRef()
  const dateRef = useRef()
  const monthRef = useRef()
  const yearRef = useRef()
  const addressRef = useRef()
  const expireDateRef = useRef()
  const expireMonthRef = useRef()
  const expireYearRef = useRef()
  const phoneNoRef = useRef()
  const placesRef = useRef()
  const citizenshipRef = useRef()
  const dropdownRef = useRef()
  const dropdownDocumentRef = useRef()
  const dropdownGenderRef = useRef()
  const dropdownStateRef = useRef()
  const cityRef = useRef()


  const [idWrongFormat, setIdWrongFormat] = useState(false)
  const [notValidDay, setNotValidDay] = useState(false)
  const [notValidMonth, setNotValidMonth] = useState(false)
  const [notValidYear, setNotValidYear] = useState(false)

  //its issue date
  const [notValidExpireDay, setNotValidExpireDay] = useState(false)
  const [notValidExpireMonth, setNotValidExpireMonth] = useState(false)
  const [notValidExpireYear, setNotValidExpireYear] = useState(false)

  const [expireDateError, setExpireDateError] = useState(false)

  const [phoneNoWrongFormat, setPhoneNoWrongFormat] = useState(false)

  const [isButtonLoading, setIsButtonLoading] = useState(false)


  const [modalVisible, setModalVisible] = useState(false)
  const [modalData, setModal] = useState({
    modalTitle: 'acquisition_default_error',
    modalSubTitle: '',
    withSecondaryButton: false,
    onPrimaryButtonPress: () => setModalVisible(false),
    primaryButtonTitle: 'acquisition_close',
    onSecondaryButtonPress: () => { },
    secondaryButtonTitle: '',
  })


  const [isCameraOpen, setIsCameraOpen] = useState(false)

  //permissions
  // const cameraPermissions = Platform.OS === 'ios' ? Permissions.PERMISSIONS.IOS.CAMERA : Permissions.PERMISSIONS.ANDROID.CAMERA
  //ios checks microphone permissions
  // const microphonePermission = Permissions.PERMISSIONS.IOS.MICROPHONE

  // const openSettings = () => Permissions.openSettings()


  //Camera
  const [frontIdPhoto, setFrontIdPhoto] = useState()
  const [frontIdPhotoBase64, setFrontIdPhotoBase64] = useState()
  const [backIdPhoto, setBackIdPhoto] = useState()
  const [backIdPhotoBase64, setBackIdPhotoBase64] = useState()
  const [selfie, setSelfie] = useState()
  const [selfieBase64, setSelfieBase64] = useState()

  const idInfo = {
    frontIdPhoto,
    setFrontIdPhoto,
    setFrontIdPhotoBase64,
    backIdPhoto,
    setBackIdPhoto,
    setBackIdPhotoBase64,
    selfie,
    setSelfie,
    setSelfieBase64,
  }

  const postFormData = () => {
    setIsButtonLoading(true)
    if (showExtendedCards) {
      postForm((type, data) => {
        setIsButtonLoading(false)
        if (type === 'success') {
          changeCurrentIndex(currentIndex + 1)
        } else {
          setModalVisible(true)
          setModal({
            withSecondaryButton: false,
            onPrimaryButtonPress: () => setModalVisible(false),
            primaryButtonTitle: 'acquisition_close',
            modalTitle: 'acquisition_default_error',
            modalSubTitle: data || 'acquisition_default_error_message',
          })
        }
      })
    } else {
      verifyCostumer((type, data) => {
        setIsButtonLoading(false)
        if (type === 'success') {
          changeCurrentIndex(currentIndex + 1)
        } else {
          setModalVisible(true)
          setModal({
            modalTitle: 'acquisition_error_id_not_found',
            modalSubTitle: data || 'acquisition_default_error_message',
            secondaryButtonTitle: 'acquisition_id_step_register',
            onSecondaryButtonPress: () => {
              setIsCostumer(false)
              setModalVisible(false)
              // scrollRef?.current?.scrollTo({ x: 0, y: 0, animated: true })
            },
            onPrimaryButtonPress: () => setModalVisible(false),
            primaryButtonTitle: 'acquisition_try_again',
            withSecondaryButton: true,
          })
        }
      })
    }
  }

  const checkId = () => {
    const valid = validatePersonalNumber(personalInfo.idNumber)
    setIdWrongFormat(!valid)
  }

  const checkPhoneNumber = () => {
    const valid = validatePhoneNumber(addressInfo.mobileNo)
    setPhoneNoWrongFormat(!valid)
  }

  const checkDate = () => {
    const date = parseInt(personalInfo.day, 10)
    if (date > 31 || date < 1) {
      setNotValidDay(true)
    } else {
      setNotValidDay(false)
      checkFullDate()
    }
  }

  const checkExpireDate = () => {
    const date = parseInt(personalInfo.expirationDate, 10)
    if (date > 31 || date < 1) {
      setNotValidExpireDay(true)
    } else {
      setNotValidExpireDay(false)
      checkFullExpireDate()
    }
  }

  const checkMonth = () => {
    const date = parseInt(personalInfo.month, 10)
    if (date > 12 || date < 1) {
      setNotValidMonth(true)
    } else {
      setNotValidMonth(false)
      checkFullDate()
    }
  }

  const checkExpireMonth = () => {
    const date = parseInt(personalInfo.expirationMonth, 10)
    if (date > 12 || date < 1) {
      setNotValidExpireMonth(true)
    } else {
      setNotValidExpireMonth(false)
      checkFullExpireDate()
    }
  }

  const checkYear = () => {
    const date = parseInt(personalInfo.year, 10)
    if (date > (new Date().getFullYear() - 16) || date < 1900) {
      setNotValidYear(true)
    } else {
      setNotValidYear(false)
      checkFullDate()
    }
  }

  const checkExpireYear = () => {
    const date = parseInt(personalInfo.expirationYear, 10)
    //checkFullExpireDate()
    if (date <= (new Date().getFullYear()) && (date >= (new Date().getFullYear() - 10))) {
      setNotValidExpireYear(false)
      checkFullExpireDate()
    } else {
      setNotValidExpireYear(true)
    }
  }
  const checkFullDate = () => {
    if (personalInfo.day && personalInfo.month && personalInfo.year) {

      const formatedDay = parseInt(personalInfo.day, 10) < 10 ? '0' + parseInt(personalInfo.day, 10).toString() : parseInt(personalInfo.day, 10).toString()

      const formatedMonth = parseInt(personalInfo.month, 10) < 10 ? '0' + parseInt(personalInfo.month, 10).toString() : parseInt(personalInfo.month, 10).toString()
      const date = personalInfo.year + '-' + formatedMonth + '-' + formatedDay

      const formatedDate = moment(moment(date).format('DD-MM-YYYY'), 'DD-MM-YYYY', true)

      const isDate = formatedDate.isValid()

      if (!isDate) {
        setNotValidDay(true)
        // setNotValidMonth(true)
        // setNotValidYear(true)
      } else {
        setNotValidDay(false)
        setNotValidMonth(false)
        setNotValidYear(false)
      }
    }
  }

  const checkFullExpireDate = () => {
    if (personalInfo.expirationDate && personalInfo.expirationMonth && personalInfo.expirationYear) {

      const formatedDay = parseInt(personalInfo.expirationDate, 10) < 10 ? '0' + parseInt(personalInfo.expirationDate, 10).toString() : parseInt(personalInfo.expirationDate, 10).toString()

      const formatedMonth = parseInt(personalInfo.expirationMonth, 10) < 10 ? '0' + parseInt(personalInfo.expirationMonth, 10).toString() : parseInt(personalInfo.expirationMonth, 10).toString()
      const date = personalInfo.expirationYear + '-' + formatedMonth + '-' + formatedDay

      const formatedDate = moment(moment(date).format('DD-MM-YYYY'), 'DD-MM-YYYY', true)

      const isDate = formatedDate.isValid()

      if (!isDate) {
        setNotValidDay(true)
        // setNotValidMonth(true)
        // setNotValidYear(true)
      } else {
        if (formatedDate.isAfter(moment())) {
          setExpireDateError(true)
        } else {
          setExpireDateError(false)
        }
        setNotValidDay(false)
        setNotValidMonth(false)
        setNotValidYear(false)
      }
    }
  }


  const isButtonDisabled = () => {
    if (showExtendedCards) {
      const isDisabled = !personalInfo?.name || !personalInfo?.surname || !personalInfo?.day ||
        !personalInfo?.month || !personalInfo?.year || !personalInfo?.birthplace ||
        !personalInfo?.country || !personalInfo?.citizenship || !personalInfo?.gender ||
        !personalInfo?.idNumber || !personalInfo?.documentType || !personalInfo?.expirationDate ||
        !personalInfo?.expirationMonth || !personalInfo?.expirationYear || idWrongFormat || notValidDay
        || notValidMonth || notValidYear || notValidExpireDay || notValidExpireMonth || notValidExpireYear
        || expireDateError || phoneNoWrongFormat || !addressInfo?.mobileNo || !addressInfo?.address || !addressInfo?.city

      return isDisabled
    } else {
      const isDisabled = !personalInfo?.name || !personalInfo?.surname || !personalInfo?.day ||
        !personalInfo?.month || !personalInfo?.year || !personalInfo?.idNumber || idWrongFormat || notValidDay
        || notValidMonth || notValidYear || !addressInfo?.address || !addressInfo?.city
      return isDisabled
    }
  }


  const closeDropdown = () => {
    if (dropdownRef?.current) {
      dropdownRef.current?.close?.()
    }
    if (placesRef?.current) {
      placesRef.current?.close?.()
    }
    if (dropdownDocumentRef?.current) {
      dropdownDocumentRef.current?.close?.()
    }
    if (dropdownGenderRef?.current) {
      dropdownGenderRef.current?.close?.()
    }
    if (dropdownStateRef?.current) {
      dropdownStateRef.current?.close?.()
    }

    Keyboard.dismiss()
  }

  // const checkPermissionsIOS = () => {
  //   Permissions.checkMultiple([cameraPermissions, microphonePermission]).then(statuses => {
  //     const cameraStatus = statuses[cameraPermissions]
  //     const microphoneStatus = statuses[microphonePermission]

  //     if (cameraStatus === RESULTS.UNAVAILABLE || microphoneStatus === RESULTS.UNAVAILABLE) {
  //       setModalVisible(true)
  //       setModal({
  //         modalTitle: 'acquisition_camera_unavailable',
  //         modalSubTitle: 'acquisition_camera_unavailable_subtitle',
  //         onPrimaryButtonPress: () => setModalVisible(false),
  //         primaryButtonTitle: 'acquisition_close',
  //         withSecondaryButton: false,
  //       })
  //       return
  //     } else if (cameraStatus === RESULTS.DENIED || microphoneStatus === RESULTS.DENIED) {
  //       if (cameraStatus === RESULTS.DENIED) {
  //         Permissions.request(cameraPermissions).then(() => checkPermissionsIOS())
  //       } else {
  //         Permissions.request(microphonePermission).then(() => checkPermissionsIOS())
  //       }
  //     } else if (cameraStatus === RESULTS.GRANTED && microphoneStatus === RESULTS.GRANTED) {
  //       setIsCameraOpen(true)
  //       return
  //     } else if (cameraStatus === RESULTS.BLOCKED || microphoneStatus === RESULTS.BLOCKED) {
  //       setModalVisible(true)
  //       setModal({
  //         modalTitle: 'acquisition_camera_permission_denied',
  //         modalSubTitle: 'acquisition_camera_permission_denied_ios_subtitle',
  //         onPrimaryButtonPress: openSettings,
  //         primaryButtonTitle: 'acquisition_camera_go_to_settings',
  //         withSecondaryButton: false,
  //       })
  //       return
  //     }
  //   })
  // }

  // const checkPermissionsAndroid = () => {
  //   Permissions.check(cameraPermissions).then(status => {
  //     switch (status) {
  //       case RESULTS.UNAVAILABLE:
  //         setModalVisible(true)
  //         setModal({
  //           modalTitle: 'acquisition_camera_unavailable',
  //           modalSubTitle: 'acquisition_camera_unavailable_subtitle',
  //           onPrimaryButtonPress: () => setModalVisible(false),
  //           primaryButtonTitle: 'acquisition_close_modal',
  //           withSecondarButton: false,
  //         })
  //         break
  //       case RESULTS.GRANTED:
  //         setIsCameraOpen(true)
  //         break
  //       case RESULTS.DENIED:
  //         Permissions.request(cameraPermissions).then(result => {
  //           if (result == RESULTS.BLOCKED) {
  //             setModalVisible(true)
  //             setModal({
  //               modalTitle: 'acquisition_camera_permission_denied',
  //               modalSubTitle: 'acquisition_camera_permission_denied_subtitle',
  //               onPrimaryButtonPress: openSettings,
  //               primaryButtonTitle: 'acquisition_camera_go_to_settings',
  //               withSecondaryButton: false,
  //             })
  //           }
  //         })
  //         break
  //       case RESULTS.BLOCKED:
  //         setModalVisible(true)
  //         setModal({
  //           modalTitle: 'acquisition_camera_permission_denied',
  //           modalSubTitle: 'acquisition_camera_permission_denied_subtitle',
  //           onPrimaryButtonPress: openSettings,
  //           primaryButtonTitle: 'acquisition_camera_go_to_settings',
  //           withSecondaryButton: false,
  //         })
  //         break
  //       case RESULTS.LIMITED:
  //         setModalVisible(true)
  //         setModal({
  //           modalTitle: 'acquisition_camera_permission_denied',
  //           modalSubTitle: 'acquisition_camera_permission_denied_subtitle',
  //           onPrimaryButtonPress: openSettings,
  //           primaryButtonTitle: 'acquisition_camera_go_to_settings',
  //           withSecondaryButton: false,
  //         })
  //         break
  //     }
  //   })
  // }

  // const checkPermissions = () => {
  //   if (Platform.OS === 'ios') {
  //     checkPermissionsIOS()
  //   } else {
  //     checkPermissionsAndroid()
  //   }
  // }

  const toggleCameraModal = () => {
    setIsCameraOpen(!isCameraOpen)
  }

  const renderModal = () => {
    if (Platform.OS === 'web' && Dimensions.get('window').width > 700) {
      return (
        <_Modal
          isVisible={modalVisible}
          backdropOpacity={0.5}
          onSwipeComplete={() => setModalVisible(false)}
          onBackdropPress={() => setModalVisible(false)}
          propagateSwipe
          hideModalContentWhileAnimating
          hardwareAccelerated
          backdropTransitionOutTiming={0}
          style={{
            justifyContent: 'flex-end',
            margin: '0 !important',
            minWidth: 1920,
            maxWidth: 1920,
          }}
        >
          <View
            style={{
              minWidth: '600px',
              maxWidth: '600px',
              height: 'auto',
              backgroundColor: theme.colors.background.primary[0],
              margin: 'auto',
              padding: '20px',
              paddingTop: null,
              borderRadius: '7px',
              alignItems: 'center'
            }}
            onStartShouldSetResponder={() => true}>
            <Icon
              name={Images.warning}
              type="image"
              size={120}
              resizeMode="contain"
            />
            <VFText
              i18nKey={modalData?.errorTitle}
              style={styles.stepTitle}
            />
            <VFText
              i18nKey={error || 'acquisition_default_error_message'}
              style={styles.stepDesc(theme)}
            />

            <VFButton
              type="primary"
              title={modalData?.buttonTitle}
              // eslint-disable-next-line react-native/no-inline-styles
              style={[styles.button, { width: '100%' }]}
              onPress={() => setModalVisible(false)}
            />

            {!showExtendedCards &&
              <VFButton
                type="secondary"
                title="acquisition_id_step_register"
                // eslint-disable-next-line react-native/no-inline-styles
                style={[styles.button, { width: '100%' }]}
                onPress={modalData.onSecondaryButtonPress}
              />}
          </View>
        </_Modal>
      )
    } else {
      return (
        <Modal type="normal" visible={modalVisible} close={() => setModalVisible(false)}>
          <View style={styles.modalContainer(theme)}>
            <Icon
              name={Images.warning}
              type="image"
              size={120}
              resizeMode="contain"
            />
            <VFText
              i18nKey={modalData?.errorTitle}
              style={styles.stepTitle}
            />
            <VFText
              i18nKey={error || 'acquisition_default_error_message'}
              style={styles.stepDesc(theme)}
            />

            <VFButton
              type="primary"
              title={modalData?.buttonTitle}
              // eslint-disable-next-line react-native/no-inline-styles
              style={[styles.button, { width: '100%' }]}
              onPress={() => setModalVisible(false)}
            />

            {!showExtendedCards &&
              <VFButton
                type="secondary"
                title="acquisition_id_step_register"
                // eslint-disable-next-line react-native/no-inline-styles
                style={[styles.button, { width: '100%' }]}
                onPress={modalData.onSecondaryButtonPress}
              />}

          </View>
        </Modal>
      )
    }
  }

  if (Platform.OS === 'web' && Dimensions.get('window').width > 700) {
    return (
      <View style={{ flexGrow: 1, overflow: 'scroll' }}>
        <View>
          <VFText
            i18nKey="acquisition_id_step_title"
            style={styles.stepTitle}
          />
          <VFText
            i18nKey="acquisition_id_step_subtitle"
            style={styles.stepDesc(theme)}
          />
        </View>
        <Card contentContainerStyle={styles.container} style={styles.cardStyle} type="main">
          <View style={styles.idContainer}>
            <Icon
              name={themedImages.idCard}
              type="image"
              size={40}
              resizeMode="contain"
            />
            <View style={styles.text}>
              <VFText
                i18nKey="acquisition_id_step_card_title"
                style={styles.stepDesc(theme)}
              />
              <VFText
                i18nKey="acquisition_id_step_card_subtitle"
                style={styles.title(theme)}
              />
            </View>
          </View>
          <HorizontalLine style={styles.line(theme)} />
          <VFText
            i18nKey="acquisition_id_step_card_desc"
            style={styles.explanationText}
          />
          <View style={styles.inputsContainer}>
            <VFInput
              fieldRef={ref => {
                nameRef.current = ref
              }}
              label="acquisition_id_step_name"
              value={personalInfo.name}
              onChangeText={(text) => setPersonalInfo(prev => { return { ...prev, name: text } })}
              containerStyle={styles.halfContainer}
              labelTextStyle={styles.inputText(theme)}
              style={styles.inputText(theme)}
              tintColor={theme.colors.textInput.default.tintColor}
              baseColor={theme.colors.textInput.default.baseColor}
            />
            <VFInput
              fieldRef={ref => {
                surnameRef.current = ref
              }}
              label="acquisition_id_step_surname"
              value={personalInfo.surname}
              onChangeText={(text) => setPersonalInfo(prev => { return { ...prev, surname: text } })}
              containerStyle={styles.halfContainer}
              labelTextStyle={styles.inputText(theme)}
              style={styles.inputText(theme)}
              tintColor={theme.colors.textInput.default.tintColor}
              baseColor={theme.colors.textInput.default.baseColor}
            />
          </View>
          {!showExtendedCards && <VFInput
            fieldRef={ref => {
              idNumber.current = ref
            }}
            label="acquisition_id_step_id_number"
            value={personalInfo.idNumber}
            onChangeText={(text) => setPersonalInfo(prev => { return { ...prev, idNumber: text } })}
            containerStyle={styles.inputContainer}
            labelTextStyle={styles.inputText(theme)}
            style={styles.inputText(theme)}
            tintColor={idWrongFormat ? Colors.vfRed : theme.colors.textInput.default.tintColor}
            baseColor={idWrongFormat ? Colors.vfRed : theme.colors.textInput.default.baseColor}
            onBlur={checkId}
            helperTextColor={Colors.vfRed}
            helperText="acquisition_id_step_id_wrong_format"
            showHelperText={idWrongFormat}
          />}
          <View style={styles.inputsContainer}>
            <VFInput
              fieldRef={ref => {
                dateRef.current = ref
              }}
              label="acquisition_id_step_date"
              value={personalInfo.day}
              onChangeText={(text) => {
                let number = text
                if (parseInt(text, 10) < 10 && text[0] !== '0') {
                  number = '0' + text
                }
                setPersonalInfo(prev => { return { ...prev, day: number } })
              }}
              containerStyle={styles.datesContainer}
              labelTextStyle={styles.inputText(theme)}
              style={styles.inputText(theme)}
              tintColor={notValidDay ? Colors.vfRed : theme.colors.textInput.default.tintColor}
              baseColor={notValidDay ? Colors.vfRed : theme.colors.textInput.default.baseColor}
              onBlur={checkDate}
              helperTextColor={Colors.vfRed}
              helperText="acquisition_id_step_day_not_valid"
              showHelperText={notValidDay}
            />
            <VFInput
              fieldRef={ref => {
                monthRef.current = ref
              }}
              label="acquisition_id_step_month"
              value={personalInfo.month}
              onChangeText={(text) => {
                let number = text
                if (parseInt(text, 10) < 10 && text[0] !== '0') {
                  number = '0' + text
                }
                setPersonalInfo(prev => { return { ...prev, month: number } })
              }}
              containerStyle={styles.datesContainer}
              labelTextStyle={styles.inputText(theme)}
              style={styles.inputText(theme)}
              tintColor={notValidMonth ? Colors.vfRed : theme.colors.textInput.default.tintColor}
              baseColor={notValidMonth ? Colors.vfRed : theme.colors.textInput.default.baseColor}
              onBlur={checkMonth}
              helperTextColor={Colors.vfRed}
              helperText="acquisition_id_step_month_not_valid"
              showHelperText={notValidMonth}
            />
            <VFInput
              fieldRef={ref => {
                yearRef.current = ref
              }}
              label="acquisition_id_step_year"
              value={personalInfo.year}
              onChangeText={(text) => setPersonalInfo(prev => { return { ...prev, year: text } })}
              containerStyle={styles.datesContainer}
              labelTextStyle={styles.inputText(theme)}
              style={styles.inputText(theme)}
              tintColor={notValidYear ? Colors.vfRed : theme.colors.textInput.default.tintColor}
              baseColor={notValidYear ? Colors.vfRed : theme.colors.textInput.default.baseColor}
              onBlur={checkYear}
              helperTextColor={Colors.vfRed}
              helperText="acquisition_id_step_year_not_valid"
              showHelperText={notValidYear}
            />
          </View>
          {showExtendedCards && <VFInput
            fieldRef={ref => {
              placesRef.current = ref
            }}
            label="acquisition_id_step_birthplace"
            value={personalInfo?.birthplace}
            onChangeText={(text) => {
              // handleOptions(text)
              setPersonalInfo(prev => { return { ...prev, birthplace: text } })
              //setPersonalInfo(prev => { return { ...prev, birthplace: text } })
            }}
            containerStyle={styles.inputContainer}
            labelTextStyle={styles.inputText(theme)}
            style={styles.inputText(theme)}
            tintColor={theme.colors.textInput.default.tintColor}
            baseColor={theme.colors.textInput.default.baseColor}
          />}
          {/* {showExtendedCards && <>
              {placesOptions.map((item, index) => {
                return (
                  <TouchableOpacity
                    style={styles.optionStyle(index === placesOptions?.length - 1)}
                    onPress={() => {
                      setPersonalInfo(prev => { return { ...prev, birthplace: item?.value } })
                      placesRef?.current?.setValue(item?.value)
                      // setPlacesOptions([])
                    }}
                  >
                    <VFText
                      i18nKey={item?.label}
                      style={styles.inputText}
                    />
                  </TouchableOpacity>
                )
              })}
            </>} */}
          {showExtendedCards && <VFDropdown
            style={styles.inputContainer}
            items={countriesList}
            placeholder={{ label: 'acquisition_id_step_birthcountry' }}
            value={citiesList.find(el => el.value === personalInfo.country)?.label}
            labelStyle={styles.inputText}
            itemTextStyle={styles.inputText}
            onValueChange={(value) => setPersonalInfo(prev => { return { ...prev, country: value } })}
            zIndex={99999}
          />}
          {showExtendedCards && <VFInput
            fieldRef={ref => {
              citizenshipRef.current = ref
            }}
            label="acquisition_id_step_citizenship"
            value={personalInfo.citizenship}
            onChangeText={(text) => setPersonalInfo(prev => { return { ...prev, citizenship: text } })}
            containerStyle={styles.inputContainer}
            labelTextStyle={styles.inputText(theme)}
            style={styles.inputText(theme)}
            tintColor={theme.colors.textInput.default.tintColor}
            baseColor={theme.colors.textInput.default.baseColor}
          />}
          {showExtendedCards && <VFDropdown
            style={styles.inputContainer}
            items={gendersList}
            placeholder={{ label: 'acquisition_id_step_gender' }}
            value={citiesList.find(el => el.value === personalInfo.gender)?.label}
            labelStyle={styles.inputText}
            itemTextStyle={styles.inputText}
            onValueChange={(value) => setPersonalInfo(prev => { return { ...prev, gender: value } })}
            zIndex={999}
            dropDownStyles={{ top: '250px' }}
          />}

          {showExtendedCards && <VFInput
            fieldRef={ref => {
              idNumber.current = ref
            }}
            label="acquisition_id_step_id_number"
            value={personalInfo.idNumber}
            onChangeText={(text) => setPersonalInfo(prev => { return { ...prev, idNumber: text } })}
            containerStyle={styles.inputContainer}
            labelTextStyle={styles.inputText(theme)}
            style={styles.inputText(theme)}
            tintColor={idWrongFormat ? Colors.vfRed : theme.colors.textInput.default.tintColor}
            baseColor={idWrongFormat ? Colors.vfRed : theme.colors.textInput.default.baseColor}
            onBlur={checkId}
            helperTextColor={Colors.vfRed}
            helperText="acquisition_id_step_id_wrong_format"
            showHelperText={idWrongFormat}
          />}

          {showExtendedCards && <VFDropdown
            style={styles.inputContainer}
            items={documentTypeList}
            placeholder={{ label: 'acquisition_id_step_document_type' }}
            value={citiesList.find(el => el.value === personalInfo.documentType)?.label}
            labelStyle={styles.inputText}
            itemTextStyle={styles.inputText}
            onValueChange={(value) => setPersonalInfo(prev => { return { ...prev, documentType: value } })}
            zIndex={999}
            dropDownStyles={{ top: '250px' }}
          />}
          {showExtendedCards && <>
            <VFText
              i18nKey="acquisition_id_issue_date"
              style={[styles.stepDesc(theme), { marginTop: 10 }]}
            />
            <View style={styles.inputsContainer}>
              <VFInput
                fieldRef={ref => {
                  expireDateRef.current = ref
                }}
                label="acquisition_id_step_date"
                value={personalInfo.expirationDate}
                onChangeText={(text) => {
                  let number = text
                  if (parseInt(text, 10) < 10 && text[0] !== '0') {
                    number = '0' + text
                  }
                  setPersonalInfo(prev => { return { ...prev, expirationDate: number } })
                }}
                containerStyle={styles.datesContainer}
                labelTextStyle={styles.inputText(theme)}
                style={styles.inputText(theme)}
                tintColor={notValidExpireDay ? Colors.vfRed : theme.colors.textInput.default.tintColor}
                baseColor={notValidExpireDay ? Colors.vfRed : theme.colors.textInput.default.baseColor}
                onBlur={checkExpireDate}
                helperTextColor={Colors.vfRed}
                helperText="acquisition_id_step_day_not_valid"
                showHelperText={notValidExpireDay}
              />
              <VFInput
                fieldRef={ref => {
                  expireMonthRef.current = ref
                }}
                label="acquisition_id_step_month"
                value={personalInfo.expirationMonth}
                onChangeText={(text) => {
                  let number = text
                  if (parseInt(text, 10) < 10 && text[0] !== '0') {
                    number = '0' + text
                  }
                  setPersonalInfo(prev => { return { ...prev, expirationMonth: number } })
                }}
                containerStyle={styles.datesContainer}
                labelTextStyle={styles.inputText(theme)}
                style={styles.inputText(theme)}
                tintColor={notValidExpireMonth ? Colors.vfRed : theme.colors.textInput.default.tintColor}
                baseColor={notValidExpireMonth ? Colors.vfRed : theme.colors.textInput.default.baseColor}
                onBlur={checkExpireMonth}
                helperTextColor={Colors.vfRed}
                helperText="acquisition_id_step_month_not_valid"
                showHelperText={notValidExpireMonth}
              />
              <VFInput
                fieldRef={ref => {
                  expireYearRef.current = ref
                }}
                label="acquisition_id_step_year"
                value={personalInfo.expirationYear}
                onChangeText={(text) => setPersonalInfo(prev => { return { ...prev, expirationYear: text } })}
                containerStyle={styles.datesContainer}
                labelTextStyle={styles.inputText(theme)}
                style={styles.inputText(theme)}
                tintColor={notValidExpireYear ? Colors.vfRed : theme.colors.textInput.default.tintColor}
                baseColor={notValidExpireYear ? Colors.vfRed : theme.colors.textInput.default.baseColor}
                onBlur={checkExpireYear}
                helperTextColor={Colors.vfRed}
                helperText="acquisition_id_step_year_not_valid"
                showHelperText={notValidExpireYear}
              />
            </View></>}
          {expireDateError && <VFText
            i18nKey="aquisition_id_step_issueing_date_not_valid"
            style={styles.errorText}
          />}
        </Card>

        <View style={styles.headerContainer}>
          <VFText
            i18nKey="acquisition_id_step_address_title"
            style={styles.stepTitle}
          />
          <VFText
            i18nKey="acquisition_id_step_address_subtitle"
            style={styles.stepDesc(theme)}
          />
        </View>

        <Card contentContainerStyle={styles.container} style={styles.cardStyle} type="main">
          <View style={styles.idContainer}>
            <Icon
              name={themedImages.address}
              type="image"
              size={40}
              resizeMode="contain"
            />
            <View style={styles.text}>
              <VFText
                i18nKey="acquisition_id_step_card_address_title"
                style={styles.stepDesc(theme)}
              />
              <VFText
                i18nKey="acquisition_id_step_card_address_subtitle"
                style={styles.title(theme)}
              />
            </View>
          </View>
          <HorizontalLine style={styles.line(theme)} />
          {showExtendedCards && <VFInput
            fieldRef={ref => {
              phoneNoRef.current = ref
            }}
            label="acquisition_id_step_mobile"
            value={addressInfo.mobileNo}
            onChangeText={(text) => setAddressInfo(prev => { return { ...prev, mobileNo: text } })}
            containerStyle={styles.inputContainer}
            labelTextStyle={styles.inputText(theme)}
            style={styles.inputText(theme)}
            tintColor={phoneNoWrongFormat ? Colors.vfRed : theme.colors.textInput.default.tintColor}
            baseColor={phoneNoWrongFormat ? Colors.vfRed : theme.colors.textInput.default.baseColor}
            onBlur={checkPhoneNumber}
            helperTextColor={Colors.vfRed}
            helperText="acquisition_id_step_phone_number_wrong_format"
            showHelperText={phoneNoWrongFormat}
          />}
          {showExtendedCards && <VFInput
            fieldRef={ref => {
              addressRef.current = ref
            }}
            label="acquisition_id_step_address"
            value={personalInfo.address}
            onChangeText={(text) => setAddressInfo(prev => { return { ...prev, address: text } })}
            containerStyle={styles.inputContainer}
            labelTextStyle={styles.inputText(theme)}
            style={styles.inputText(theme)}
            tintColor={theme.colors.textInput.default.tintColor}
            baseColor={theme.colors.textInput.default.baseColor}
          />}
          {showExtendedCards && <VFDropdown
            style={styles.inputContainer}
            items={countriesList}
            placeholder={{ label: 'acquisition_id_step_country' }}
            value={countriesList.find(el => el.value === addressInfo.countryAddress)?.label}
            labelStyle={styles.inputText}
            itemTextStyle={styles.inputText}
            onValueChange={(value) => setAddressInfo(prev => { return { ...prev, countryAddress: value } })}
            zIndex={3}
          />}
          <View style={{ flexDirection: 'row', gap: 16 }}>
            {!showExtendedCards && <VFDropdown
              style={[styles.inputContainer]}
              items={citiesList}
              placeholder={{ label: 'acquisition_id_step_city' }}
              value={citiesList.find(el => el.value === addressInfo.city)?.label}
              labelStyle={styles.inputText}
              itemTextStyle={styles.inputText}
              onValueChange={(value) => setAddressInfo(prev => { return { ...prev, city: value } })}
              zIndex={2}
              ref={cityRef}
              containerStyle={{ flex: 1, marginTop: 0 }}
            />}
            {showExtendedCards && <View style={{ flex: 1 }}>
              {showExtendedCards && <VFInput
                fieldRef={ref => {
                  // addressCityRef.current = ref
                }}
                label="acquisition_id_step_city"
                value={addressInfo?.city}
                onChangeText={(text) => {
                  // handleCityOptions(text)
                  setAddressInfo(prev => { return { ...prev, city: text } })
                }}
                containerStyle={[styles.inputContainer, { flex: 1 }]}
                labelTextStyle={styles.inputText(theme)}
                style={styles.inputText(theme)}
                tintColor={theme.colors.textInput.default.tintColor}
                baseColor={theme.colors.textInput.default.baseColor}
              />}
              {/* {showExtendedCards && <>
                  {citiesOption.map((item, index) => {
                    return (
                      <TouchableOpacity
                        style={styles.optionStyle(index === citiesOption?.length - 1)}
                        onPress={() => {
                          setPersonalInfo(prev => { return { ...prev, city: item?.value } })
                          addressCityRef?.current?.setValue(item?.value)
                          setPlacesOptions([])
                        }}
                      >
                        <VFText
                          i18nKey={item?.label}
                          style={styles.inputText}
                        />
                      </TouchableOpacity>
                    )
                  })}
                </>} */}
            </View>}
            {!showExtendedCards && <VFInput
              fieldRef={ref => {
                addressRef.current = ref
              }}
              label="acquisition_id_step_address"
              value={personalInfo.address}
              onChangeText={(text) => setAddressInfo(prev => { return { ...prev, address: text } })}
              containerStyle={[styles.inputContainer, { flex: 1 }]}
              labelTextStyle={styles.inputText(theme)}
              style={styles.inputText(theme)}
              tintColor={theme.colors.textInput.default.tintColor}
              baseColor={theme.colors.textInput.default.baseColor}
            />}
          </View>
          {/* {showExtendedCards && <VFDropdown
                 style={styles.inputContainer}
                 items={channelList}
                 placeholder={{ label: 'acquisition_id_step_channel' }}
                 value={citiesList.find(el => el.value === addressInfo.channel)?.label}
                 labelStyle={styles.inputText}
                 itemTextStyle={styles.inputText}
                  onValueChange={(value) => setAddressInfo(prev => { return { ...prev, channel: value } })}
                  zIndex={1}
               />} */}
        </Card>

        <VFButton
          type="primary"
          title="acquisition_continue"
          style={styles.button}
          disabled={isButtonDisabled()}
          onPress={postFormData}
          isLoading={isButtonLoading}
          loadingTitle="acquisition_loading_button"
        />
        {renderModal()}
      </View>
    )
  }

  return (
    <TouchableWithoutFeedback onPress={closeDropdown}>
      <View>
        <View style={styles.firstHeader}>
          <VFText
            i18nKey="acquisition_id_step_title"
            style={styles.stepTitle}
          />
          <VFText
            i18nKey="acquisition_id_step_subtitle"
            style={styles.stepDesc(theme)}
          />
        </View>
        <Card contentContainerStyle={styles.container} style={styles.cardStyle} type="main">
          <View style={styles.idContainer}>
            <Icon
              name={themedImages.idCard}
              type="image"
              size={40}
              resizeMode="contain"
            />
            <View style={styles.text}>
              <VFText
                i18nKey="acquisition_id_step_card_title"
                style={styles.stepDesc(theme)}
              />
              <VFText
                i18nKey="acquisition_id_step_card_subtitle"
                style={styles.title(theme)}
              />
            </View>
          </View>
          <HorizontalLine style={styles.line(theme)} />
          <VFText
            i18nKey="acquisition_id_step_card_desc"
            style={styles.explanationText}
          />
          {/* <VFButton
            type="primary"
            title={(idInfo?.frontIdPhoto && idInfo?.backIdPhoto && idInfo?.selfie) ? 'acquisition_id_step_button_uploaded_id_photo' : 'acquisition_id_step_button_take_id_photo'}
            onPress={checkPermissions}
            style={styles.takeidButton}
            disabled={idInfo?.frontIdPhoto && idInfo?.backIdPhoto && idInfo?.selfie}
          /> */}

          <HorizontalLine style={styles.line(theme)} />

          {/* name surname */}
          <View style={[styles.inputsContainer, styles.marginStyle]}>
            <VFInput
              fieldRef={ref => {
                nameRef.current = ref
              }}
              label="acquisition_id_step_name"
              value={personalInfo.name}
              onChangeText={(text) => setPersonalInfo(prev => { return { ...prev, name: text } })}
              containerStyle={styles.halfContainer}
              labelTextStyle={styles.inputText(theme)}
              style={styles.inputText(theme)}
              tintColor={theme.colors.textInput.default.tintColor}
              baseColor={theme.colors.textInput.default.baseColor}
            />
            <VFInput
              fieldRef={ref => {
                surnameRef.current = ref
              }}
              label="acquisition_id_step_surname"
              value={personalInfo.surname}
              onChangeText={(text) => setPersonalInfo(prev => { return { ...prev, surname: text } })}
              containerStyle={styles.halfContainer}
              labelTextStyle={styles.inputText(theme)}
              style={styles.inputText(theme)}
              tintColor={theme.colors.textInput.default.tintColor}
              baseColor={theme.colors.textInput.default.baseColor}
            />
          </View>

          {/* id when user is registered */}
          {!showExtendedCards &&
            <View style={styles.marginStyle}>
              <VFInput
                fieldRef={ref => {
                  idNumber.current = ref
                }}
                label="acquisition_id_step_id_number"
                value={personalInfo.idNumber}
                onChangeText={(text) => setPersonalInfo(prev => { return { ...prev, idNumber: text } })}
                containerStyle={styles.inputContainer}
                labelTextStyle={styles.inputText(theme)}
                style={styles.inputText(theme)}
                tintColor={idWrongFormat && personalInfo.idNumber.length !== 0 ? theme.colors.textInput.error.tintColor : theme.colors.textInput.default.tintColor}
                baseColor={idWrongFormat && personalInfo.idNumber.length !== 0 ? theme.colors.textInput.error.tintColor : theme.colors.textInput.default.baseColor}
                onBlur={checkId}
                helperTextColor={theme.colors.textInput.error.tintColor}
                helperText="acquisition_id_step_id_wrong_format"
                showHelperText={idWrongFormat && personalInfo.idNumber.length !== 0}
              />
            </View>
          }

          {/* birthday */}
          <View style={styles.marginStyle}>
            <VFText
              i18nKey="acquisition_id_step_birthday_label"
              style={styles.birthDayLabel}
            />
            <View style={styles.inputsContainer}>
              <VFInput
                fieldRef={ref => {
                  dateRef.current = ref
                }}
                label="acquisition_id_step_date"
                value={personalInfo.day}
                onChangeText={(text) => {
                  let number = text
                  if (parseInt(text, 10) < 10 && text[0] !== '0') {
                    number = '0' + text
                  }
                  setPersonalInfo(prev => { return { ...prev, day: number } })
                }}
                containerStyle={styles.datesContainer}
                labelTextStyle={styles.inputText(theme)}
                style={styles.inputText(theme)}
                tintColor={notValidDay ? theme.colors.textInput.error.tintColor : theme.colors.textInput.default.tintColor}
                baseColor={notValidDay ? theme.colors.textInput.error.tintColor : theme.colors.textInput.default.baseColor}
                onBlur={checkDate}
                helperTextColor={theme.colors.textInput.error.tintColor}
                helperText="acquisition_id_step_day_not_valid"
                showHelperText={notValidDay}
                keyboardType="numeric"
              />
              <VFInput
                fieldRef={ref => {
                  monthRef.current = ref
                }}
                label="acquisition_id_step_month"
                value={personalInfo.month}
                onChangeText={(text) => {
                  let number = text
                  if (parseInt(text, 10) < 10 && text[0] !== '0') {
                    number = '0' + text
                  }
                  setPersonalInfo(prev => { return { ...prev, month: number } })
                }}
                containerStyle={styles.datesContainer}
                labelTextStyle={styles.inputText(theme)}
                style={styles.inputText(theme)}
                tintColor={notValidMonth ? theme.colors.textInput.error.tintColor : theme.colors.textInput.default.tintColor}
                baseColor={notValidMonth ? theme.colors.textInput.error.tintColor : theme.colors.textInput.default.baseColor}
                onBlur={checkMonth}
                helperTextColor={theme.colors.textInput.error.tintColor}
                helperText="acquisition_id_step_month_not_valid"
                showHelperText={notValidMonth}
                keyboardType="numeric"
              />

              <VFInput
                fieldRef={ref => {
                  yearRef.current = ref
                }}
                label="acquisition_id_step_year"
                value={personalInfo.year}
                onChangeText={(text) => setPersonalInfo(prev => { return { ...prev, year: text } })}
                containerStyle={styles.datesContainer}
                labelTextStyle={styles.inputText(theme)}
                style={styles.inputText(theme)}
                tintColor={notValidYear ? theme.colors.textInput.error.tintColor : theme.colors.textInput.default.tintColor}
                baseColor={notValidYear ? theme.colors.textInput.error.tintColor : theme.colors.textInput.default.baseColor}
                onBlur={checkYear}
                helperTextColor={theme.colors.textInput.error.tintColor}
                helperText="acquisition_id_step_year_not_valid"
                showHelperText={notValidYear}
                keyboardType="numeric"
              />
            </View>
          </View>

          {/* city of birth */}
          {showExtendedCards &&
            <View style={[styles.marginStyle, { zIndex: 11 }]}>
              <VFDropdown
                style={styles.dropdownSearchable}
                items={citiesList}
                ref={placesRef}
                value={citiesList.find(el => el.value === personalInfo?.birthplace)?.label}
                onValueChange={(value) => setPersonalInfo(prev => { return { ...prev, birthplace: value } })}
                selectedItem={citiesList.find(el => el.value === personalInfo?.birthplace) || {}}
                isSearchable={true}
                placeholder={{ label: 'acquisition_id_step_birthplace' }}
                placeholderStyle={styles.inputText(theme)}
                itemTextStyle={styles.inputText(theme)}
                titleStyle={{ color: theme.colors.textInput.default.baseColor }}
                activeBorderColor={theme.colors.textInput.default.baseColor}
                textColor={theme.colors.textColor}
                borderColor={theme.colors.textInput.default.baseColor}
                containerStyle={styles.dropdownSearchable}
                labelStyle={styles.inputText(theme)}
                flatListProps={{
                  keyboardShouldPersistTaps: 'always',
                }}
                dropDownStyle={styles.dropdownStyle}
                zIndex={3000}
                containerProps={{
                  onStartShouldSetResponder: () => true
                }}
              />
            </View>
          }

          {/* birth country */}
          {showExtendedCards &&
            <View style={[styles.marginStyle, { zIndex: 10 }]} onStartShouldSetResponder={() => true}>
              <VFDropdown
                ref={dropdownStateRef}
                style={styles.inputContainer}
                items={countriesList}
                isSearchable={true}
                value={countriesList.find(el => el.value === personalInfo.country)?.label}
                onValueChange={(value) => setPersonalInfo(prev => { return { ...prev, country: value } })}
                selectedItem={countriesList.find(el => el.value === addressInfo.country) || {}}
                placeholder={{ label: 'acquisition_id_step_birthcountry' }}
                placeholderStyle={styles.inputText(theme)}
                itemTextStyle={styles.inputText(theme)}
                titleStyle={{ color: theme.colors.textInput.default.baseColor }}
                activeBorderColor={theme.colors.textInput.default.baseColor}
                textColor={theme.colors.textColor}
                borderColor={theme.colors.textInput.default.baseColor}
                containerStyle={styles.dropdownSearchable}
                labelStyle={styles.inputText(theme)}
                flatListProps={{
                  keyboardShouldPersistTaps: 'always',
                }}
                dropDownStyle={styles.dropdownStyle}
                zIndex={3000}
                containerProps={{
                  onStartShouldSetResponder: () => true
                }}
              />
            </View>
          }

          {/* citizenship */}
          <View style={{ zIndex: -1 }}>
            {showExtendedCards && <VFInput
              fieldRef={ref => {
                citizenshipRef.current = ref
              }}
              label="acquisition_id_step_citizenship"
              value={personalInfo.citizenship}
              onChangeText={(text) => setPersonalInfo(prev => { return { ...prev, citizenship: text } })}
              containerStyle={styles.inputContainer}
              labelTextStyle={styles.inputText(theme)}
              style={styles.inputText(theme)}
              tintColor={theme.colors.textInput.default.tintColor}
              baseColor={theme.colors.textInput.default.baseColor}
            />}
          </View>


          {/* gender */}
          {showExtendedCards &&
            <View style={[styles.marginStyle, { zIndex: 3 }]}>
              <VFDropdown
                ref={dropdownGenderRef}
                style={styles.inputContainer}
                items={gendersList}
                placeholder={{ label: 'acquisition_id_step_gender' }}
                value={gendersList.find(el => el.value === personalInfo.gender)?.label}
                labelStyle={styles.inputText}
                placeholderStyle={styles.inputText(theme)}
                itemTextStyle={styles.inputText}
                onValueChange={(value) => setPersonalInfo(prev => { return { ...prev, gender: value } })}
                zIndex={999}
                dropDownStyles={{ top: '250px' }}
              />
            </View>
          }

          {/* id number */}
          <View style={{ zIndex: -1 }}>
            {showExtendedCards &&
              <View style={styles.marginStyle}>
                <VFInput
                  fieldRef={ref => {
                    idNumber.current = ref
                  }}
                  label="acquisition_id_step_id_number"
                  value={personalInfo.idNumber}
                  onChangeText={(text) => setPersonalInfo(prev => { return { ...prev, idNumber: text } })}
                  containerStyle={styles.inputContainer}
                  labelTextStyle={styles.inputText(theme)}
                  style={styles.inputText(theme)}
                  tintColor={idWrongFormat && personalInfo.idNumber.length !== 0 ? theme.colors.textInput.error.tintColor : theme.colors.textInput.default.tintColor}
                  baseColor={idWrongFormat && personalInfo.idNumber.length !== 0 ? theme.colors.textInput.error.tintColor : theme.colors.textInput.default.baseColor}
                  onBlur={checkId}
                  helperTextColor={theme.colors.textInput.error.tintColor}
                  helperText="acquisition_id_step_id_wrong_format"
                  showHelperText={idWrongFormat && personalInfo.idNumber.length !== 0}
                />
              </View>}
          </View>

          {/* document type */}
          {showExtendedCards &&
            <View style={[styles.marginStyle, { zIndex: 3 }]}>
              <VFDropdown
                ref={dropdownDocumentRef}
                style={styles.inputContainer}
                items={documentTypeList}
                placeholder={{ label: 'acquisition_id_step_document_type' }}
                value={documentTypeList.find(el => el.value === personalInfo.documentType)?.label}
                labelStyle={styles.inputText}
                itemTextStyle={styles.inputText}
                onValueChange={(value) => setPersonalInfo(prev => { return { ...prev, documentType: value } })}
                placeholderStyle={styles.inputText(theme)}
                zIndex={999}
                dropDownStyles={{ top: '250px' }}
              />
            </View>
          }

          {/* expiration date */}
          {showExtendedCards && <View style={styles.marginStyle}>
            <VFText
              i18nKey="acquisition_id_issue_date"
              style={[styles.stepDesc(theme), { marginTop: 15 }]}
            />
            <View style={styles.inputsContainer} >
              <VFInput
                fieldRef={ref => {
                  expireDateRef.current = ref
                }}
                label="acquisition_id_step_date"
                value={personalInfo.expirationDate}
                onChangeText={(text) => {
                  let number = text
                  if (parseInt(text, 10) < 10 && text[0] !== '0') {
                    number = '0' + text
                  }
                  setPersonalInfo(prev => { return { ...prev, expirationDate: number } })
                }}
                containerStyle={styles.datesContainer}
                labelTextStyle={styles.inputText(theme)}
                style={styles.inputText(theme)}
                tintColor={notValidExpireDay ? theme.colors.textInput.error.tintColor : theme.colors.textInput.default.tintColor}
                baseColor={notValidExpireDay ? theme.colors.textInput.error.tintColor : theme.colors.textInput.default.baseColor}
                onBlur={checkExpireDate}
                helperTextColor={theme.colors.textInput.error.tintColor}
                helperText="acquisition_id_step_day_not_valid"
                showHelperText={notValidExpireDay}
                keyboardType="numeric"
              />
              <VFInput
                fieldRef={ref => {
                  expireMonthRef.current = ref
                }}
                label="acquisition_id_step_month"
                value={personalInfo.expirationMonth}
                onChangeText={(text) => {
                  let number = text
                  if (parseInt(text, 10) < 10 && text[0] !== '0') {
                    number = '0' + text
                  }
                  setPersonalInfo(prev => { return { ...prev, expirationMonth: number } })
                }}
                containerStyle={styles.datesContainer}
                labelTextStyle={styles.inputText(theme)}
                style={styles.inputText(theme)}
                tintColor={notValidExpireMonth ? theme.colors.textInput.error.tintColor : theme.colors.textInput.default.tintColor}
                baseColor={notValidExpireMonth ? theme.colors.textInput.error.tintColor : theme.colors.textInput.default.baseColor}
                onBlur={checkExpireMonth}
                helperTextColor={theme.colors.textInput.error.tintColor}
                helperText="acquisition_id_step_month_not_valid"
                showHelperText={notValidExpireMonth}
                keyboardType="numeric"
              />
              <VFInput
                fieldRef={ref => {
                  expireYearRef.current = ref
                }}
                label="acquisition_id_step_year"
                value={personalInfo.expirationYear}
                onChangeText={(text) => setPersonalInfo(prev => { return { ...prev, expirationYear: text } })}
                containerStyle={styles.datesContainer}
                labelTextStyle={styles.inputText(theme)}
                style={styles.inputText(theme)}
                tintColor={notValidExpireYear ? theme.colors.textInput.error.tintColor : theme.colors.textInput.default.tintColor}
                baseColor={notValidExpireYear ? theme.colors.textInput.error.tintColor : theme.colors.textInput.default.baseColor}
                onBlur={checkExpireYear}
                helperTextColor={theme.colors.textInput.error.tintColor}
                helperText="acquisition_id_step_year_not_valid"
                showHelperText={notValidExpireYear}
                keyboardType="numeric"
              />
            </View>
          </View>}
          {expireDateError && <VFText
            i18nKey="aquisition_id_step_issueing_date_not_valid"
            style={styles.errorText}
          />}

        </Card>

        <View style={styles.headerContainer}>
          <VFText
            i18nKey="acquisition_id_step_address_title"
            style={styles.stepTitle}
          />
          <VFText
            i18nKey="acquisition_id_step_address_subtitle"
            style={styles.stepDesc(theme)}
          />
        </View>

        <Card contentContainerStyle={styles.container} style={styles.cardStyle} type="main">
          <View style={styles.idContainer}>
            <Icon
              name={themedImages.address}
              type="image"
              size={40}
              resizeMode="contain"
            />
            <View style={styles.text}>
              <VFText
                i18nKey="acquisition_id_step_card_address_title"
                style={styles.stepDesc(theme)}
              />
              <VFText
                i18nKey="acquisition_id_step_card_address_subtitle"
                style={styles.title(theme)}
              />
            </View>
          </View>
          <HorizontalLine style={styles.line(theme)} />

          {/* mobile number */}
          <View style={styles.marginStyle}>
            <VFInput
              fieldRef={ref => {
                phoneNoRef.current = ref
              }}
              label="acquisition_id_step_mobile"
              value={addressInfo.mobileNo}
              onChangeText={(text) => setAddressInfo(prev => { return { ...prev, mobileNo: text } })}
              containerStyle={styles.inputContainer}
              labelTextStyle={styles.inputText(theme)}
              style={styles.inputText(theme)}
              tintColor={phoneNoWrongFormat && addressInfo.mobileNo.length !== 0 ? theme.colors.textInput.error.tintColor : theme.colors.textInput.default.tintColor}
              baseColor={phoneNoWrongFormat && addressInfo.mobileNo.length !== 0 ? theme.colors.textInput.error.tintColor : theme.colors.textInput.default.baseColor}
              onBlur={checkPhoneNumber}
              helperTextColor={theme.colors.textInput.error.tintColor}
              helperText="acquisition_id_step_phone_number_wrong_format"
              showHelperText={phoneNoWrongFormat && addressInfo.mobileNo.length !== 0}
              keyboardType="numeric"
            />
          </View>

          {/* city dropdown searchable */}
          <View style={[styles.marginStyle, { zIndex: 2 }]} onStartShouldSetResponder={() => true}>
            <VFDropdown
              style={styles.dropdownSearchable}
              items={citiesList}
              ref={dropdownRef}
              value={citiesList.find(el => el.value === addressInfo.city)?.label}
              onValueChange={(value) => setAddressInfo(prev => { return { ...prev, city: value } })}
              selectedItem={citiesList.find(el => el.value === addressInfo.city) || {}}
              isSearchable={true}
              placeholder={{ label: 'acquisition_id_step_city' }}
              placeholderStyle={styles.inputText(theme)}
              itemTextStyle={styles.inputText(theme)}
              titleStyle={{ color: theme.colors.textInput.default.baseColor }}
              activeBorderColor={theme.colors.textInput.default.baseColor}
              textColor={theme.colors.textColor}
              borderColor={theme.colors.textInput.default.baseColor}
              containerStyle={styles.dropdownSearchable}
              labelStyle={styles.inputText(theme)}
              flatListProps={{
                keyboardShouldPersistTaps: 'always',
              }}
              dropDownStyle={styles.dropdownStyle}
              zIndex={3000}
              containerProps={{
                onStartShouldSetResponder: () => true
              }}
            />
          </View>

          {/* street address */}
          <View style={[styles.marginStyle, { zIndex: 0 }]}>
            <VFInput
              fieldRef={ref => {
                addressRef.current = ref
              }}
              label="acquisition_id_step_address"
              value={personalInfo.address}
              onChangeText={(text) => setAddressInfo(prev => { return { ...prev, address: text } })}
              containerStyle={styles.inputContainer}
              labelTextStyle={styles.inputText(theme)}
              style={styles.inputText(theme)}
              tintColor={theme.colors.textInput.default.tintColor}
              baseColor={theme.colors.textInput.default.baseColor}
            />
          </View>
        </Card>

        <HorizontalLine style={styles.line(theme)} />

        <VFButton
          type="primary"
          title="acquisition_continue"
          style={styles.button}
          disabled={isButtonDisabled()}
          onPress={postFormData}
          isLoading={isButtonLoading}
          loadingTitle="acquisition_loading_button"
        />

        {renderModal()}

        {/* <Modal
          type="normal"
          visible={modalVisible}
          close={() => setModalVisible(false)}
        >
          <View style={styles.modalContainer(theme)}>
            <Icon
              name={Images.warning}
              type="image"
              size={120}
              resizeMode="contain"
            />
            <VFText
              i18nKey={modalData?.modalTitle}
              style={styles.stepTitle}
            />
            <VFText
              i18nKey={modalData?.modalSubTitle}
              style={styles.modalSubTitle(theme)}
            />

            <VFButton
              type="primary"
              title={modalData?.primaryButtonTitle}
              style={[styles.button, { width: '100%' }]}
              onPress={modalData?.onPrimaryButtonPress}
            />
            {modalData?.withSecondaryButton &&
              <VFButton
                type="secondary"
                title={modalData?.secondaryButtonTitle}
                style={[styles.button, { width: '100%' }]}
                onPress={modalData?.onSecondaryButtonPress}
              />}
          </View>
        </Modal>

        <Modal
          visible={isCameraOpen}
          close={toggleCameraModal}
          type="full"
          contentContainerStyle={styles.cameraModal(theme, { bottom: 0 })}
          theme={theme}
        >
          <CameraStep
            toggleCameraModal={toggleCameraModal}
            frontIdPhoto={frontIdPhoto}
            setFrontIdPhoto={setFrontIdPhoto}
            backIdPhoto={backIdPhoto}
            setBackIdPhoto={setBackIdPhoto}
            selfie={selfie}
            setSelfie={setSelfie}
            setFrontIdPhotoBase64={setFrontIdPhotoBase64}
            setBackIdPhotoBase64={setBackIdPhotoBase64}
            setSelfieBase64={setSelfieBase64}
          />
        </Modal> */}
      </View>
    </TouchableWithoutFeedback>
  )
}

Id.propTypes = {
  currentIndex: PropTypes.number,
  changeCurrentIndex: PropTypes.func,
  personalInfo: PropTypes.object,
  setPersonalInfo: PropTypes.func,
  addressInfo: PropTypes.object,
  setAddressInfo: PropTypes.func,
  showExtendedCards: PropTypes.bool,
  validatePersonalNumber: PropTypes.func,
  citiesList: PropTypes.array,
  countriesList: PropTypes.array,
  gendersList: PropTypes.array,
  documentTypeList: PropTypes.array,
  validatePhoneNumber: PropTypes.func,
  channelList: PropTypes.array,
  postForm: PropTypes.func,
  getAvaliableResources: PropTypes.func,
  API_KEY: PropTypes.string,
  setIsCostumer: PropTypes.func,
  verifyCostumer: PropTypes.func,
  theme: PropTypes.object,
  scrollRef: PropTypes.object
}

export default withTheme(Id)
